'use client';

import { usePathname } from 'next/navigation';
import { AnimatePresence, motion } from 'framer-motion';
import { pageTransition } from '@/lib/motion';

/**
 * Wraps page content with a subtle fade + 20px translate on route change.
 * Disabled automatically by `prefers-reduced-motion` via global CSS rules.
 */
export function PageTransition({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();

  return (
    <AnimatePresence mode="wait" initial={false}>
      <motion.div
        key={pathname}
        initial={pageTransition.initial}
        animate={pageTransition.animate}
        exit={pageTransition.exit}
        className="contents"
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
}
